import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";

import Button from "../../components/button";
import ICInput from "../../components/form/input";

const ConsultCostForm = props => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: props.consult !== null ? props.consult.description : "",
      duration: props.consult !== null ? props.consult.consultDuration : "",
      durationType: props.consult !== null ? props.consult.consultMode : "",
      cost: props.consult !== null ? props.consult.consultPrice : ""
    },
    validationSchema: Yup.object({
      description: Yup.string()
        .min(2, "Consult description must be of minimum length 2")
        .required("Please enter Consult Description"),
      duration: Yup.string().required("Please enter Consult Duration"),
      durationType: Yup.string().required(
        "Please select Consult Duration Type"
      ),
      cost: Yup.string().required("Please enter Consult Cost")
    }),
    onSubmit: values => {
      let formData = new FormData();
      formData.append("consultDuration", values.duration);
      formData.append("consultMode", values.durationType);
      formData.append("consultPrice", values.cost);
      formData.append("description", values.description);

      // if the form is in update state
      if (props.consult !== null) {
        formData.append("consultDetailId", props.consult._id);
        props.onEditSubmit(formData);
        formik.resetForm();
      }
      // if the form is in add state
      else {
        props.onAddSubmit(formData);
        formik.resetForm();
      }
    }
  });

  return (
    <form
      className="container d-flex flex-column mr-4 pr-4"
      onSubmit={formik.handleSubmit}
    >
      <div className="form-group row">
        <label className="col-sm-4 col-form-label">
          Consult Cost ($) <span className="error">*</span>:
        </label>
        <div className="col-sm-8">
          <ICInput
            name="cost"
            type="text"
            value={formik.values.cost}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.cost && formik.errors.cost ? true : false}
            helperText={
              formik.touched.cost && formik.errors.cost
                ? formik.errors.cost
                : ""
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label">
          Type of Duration <span className="error">*</span>:
        </label>
        <div className="col-sm-8">
          <TextField
            name="durationType"
            className="w-100"
            select
            value={formik.values.durationType}
            SelectProps={{
              native: true
            }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.durationType && formik.errors.durationType
                ? true
                : false
            }
            helperText={
              formik.touched.durationType && formik.errors.durationType
                ? formik.errors.durationType
                : ""
            }
          >
            <option>Select a duration type</option>
            <option value="<">{`<`}</option>
            <option value=">">{`>`}</option>
          </TextField>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label">
          Consult Duration (Minutes) <span className="error">*</span>:
        </label>
        <div className="col-sm-8">
          <ICInput
            name="duration"
            type="text"
            value={formik.values.duration}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.duration && formik.errors.duration ? true : false
            }
            helperText={
              formik.touched.duration && formik.errors.duration
                ? formik.errors.duration
                : ""
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label">
          Description <span className="error">*</span>:
        </label>
        <div className="col-sm-8">
          <ICInput
            name="description"
            type="text"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.description && formik.errors.description
                ? true
                : false
            }
            helperText={
              formik.touched.description && formik.errors.description
                ? formik.errors.description
                : ""
            }
          />
        </div>
      </div>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button
          title={props.consult !== null ? "Update" : "Save"}
          type="submit"
        />
      </p>
    </form>
  );
};

export default ConsultCostForm;

ConsultCostForm.defaultProps = {
  consult: null,
  onAddSubmit: () => {},
  onEditSubmit: () => {}
};

ConsultCostForm.propTypes = {
  consult: PropTypes.object,
  onAddSubmit: PropTypes.func,
  onEditSubmit: PropTypes.func
};
